import { Controller } from '@hotwired/stimulus';

/**
 * Filter form - submits the board filter form when a control changes or the user stops typing.
 * Tells the server whether the change came from inside the filter popover (so it stays open after the reload).
 * Targets: panel - hidden input, '1' when the popover must stay open
 * Values: delay (Number, ms) - debounce for typing
 * @example
 * <form data-controller="filter-form">
 *   <input type="hidden" name="panel" data-filter-form-target="panel">
 *   <input type="search" data-action="input->filter-form#typing">
 *   <div data-filter-form-popover><input type="checkbox" data-action="change->filter-form#submit"></div>
 * </form>
 */
export default class extends Controller {
  static targets = ['panel'];
  static values = { delay: { type: Number, default: 350 } };

  disconnect () {
    clearTimeout(this.timeout);
  }

  submit (event) {
    clearTimeout(this.timeout);
    this.#send(event);
  }

  typing (event) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.#send(event), this.delayValue);
  }

  #send (event) {
    if (this.hasPanelTarget) {
      this.panelTarget.value = event?.target?.closest?.('[data-filter-form-popover]') ? '1' : '';
    }
    this.element.requestSubmit();
  }
}
